export default __webpack_public_path__ + "static/media/Navigation.41eaff06.svg";